import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SystemViewModel, SystemCategory, DEFAULT_SYSTEM_CATEGORIES } from '../../models/system-view.model';

@Component({
  selector: 'app-all-systems-section',
  templateUrl: './all-systems-section.component.html',
  styleUrls: ['./all-systems-section.component.scss'],
})
export class AllSystemsSectionComponent {
  @Input() title = 'Danh sách hệ thống';
  @Input() systems: SystemViewModel[] = [];
  @Input() selectedCategory = 'all';
  @Input() categories: SystemCategory[] = [...DEFAULT_SYSTEM_CATEGORIES];
  @Input() loading = false;
  @Input() searchKeyword = '';
  @Input() showInlineSearch = true;

  @Output() categoryChange = new EventEmitter<string>();
  @Output() searchKeywordChange = new EventEmitter<string>();
  @Output() togglePin = new EventEmitter<{ systemId: string; event: MouseEvent }>();

  // Bộ icon ứng dụng nhiều màu trong assets/icon/application
  private readonly appIcons = [
    'ic_bag', 'ic_bill', 'ic_calendar', 'ic_card', 'ic_edit', 'ic_exam',
    'ic_file', 'ic_learning', 'ic_note', 'ic_to_do_list', 'ic_user',
  ];

  trackByCategory(_: number, category: SystemCategory): string {
    return category.id;
  }

  // Gán icon ổn định cho từng hệ thống dựa trên id/tên (cùng hệ thống → cùng icon)
  getSystemIcon(system: SystemViewModel): string {
    const key = system.id || system.name || '';
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    }
    const name = this.appIcons[hash % this.appIcons.length];
    return `assets/icon/application/${name}.svg`;
  }

  trackBySystem(_: number, system: SystemViewModel): string {
    return system.id;
  }

  getCardSubtitle(system: SystemViewModel): string {
    return system.description?.trim() || system.hostname || 'Hệ thống nội bộ';
  }

  selectCategory(categoryId: string): void {
    this.categoryChange.emit(categoryId);
  }

  onSearchInput(value: string): void {
    this.searchKeywordChange.emit(value);
  }

  onTogglePin(systemId: string, event: MouseEvent): void {
    this.togglePin.emit({ systemId, event });
  }
}
